import { Component } from '@angular/core';
import { AlertController, NavController, NavParams, ViewController } from 'ionic-angular';
import { ApiService } from "../../services/api.service";
import { BarcodeScanner } from "@ionic-native/barcode-scanner";
import {SearchUnitPage} from "../search-unit/search-unit";

@Component({
  selector: 'page-search-location-units',
  templateUrl: 'search-location-units.html',
})
export class SearchLocationUnitsPage {

  searchPerformed = false;
  busy = false;
  page: SearchUnitPage;

  searchType = 1;
  query = '';
  zipcode = '';
  number = '';
  units = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public alertCtrl: AlertController,
    public barcodeScanner: BarcodeScanner,
    public apiService: ApiService
  ) {
    this.page = navParams.get('page');
    // Set search type
    let user = this.apiService.getLoggedInUser();
    if(parseInt(user.search_type) === 2 || parseInt(user.search_type) === 3){
      this.searchType = parseInt(user.search_type);
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SearchLocationUnitsPage');
  }

  isValid(){
    if(
      (this.searchType === 1 && this.query.trim()) ||
      (this.searchType === 2 && this.zipcode.trim() && this.number.trim()) ||
      (this.searchType > 2 && this.searchType < 9 && this.query.trim())
    ){
      return true;
    }
    return false;
  }

  scanBarcode(){
    this.barcodeScanner.scan({
      showTorchButton: true,
      torchOn: true
    }).then(data => {
      console.log('Barcode data', data);
      let barcode = data.text;
      if(barcode.lastIndexOf('/') > 0) {
        barcode = barcode.substring(barcode.lastIndexOf('/') + 1);
      }
      if(barcode){
        this.query = barcode;
        this.search(3);
      }
    }).catch(err => {
      console.log('Error', err);
    });
  }

  search(searchType?){
    if(!searchType){
      searchType = this.searchType;
    }
    if(!this.isValid()){
      return;
    }
    this.searchPerformed = false;
    this.units = [];
    this.busy = true;
    this.apiService.searchLocationUnits(this.query, this.zipcode, this.number, searchType).then((data) => {
      // @ts-ignore
      this.units = data;
      this.busy = false;
      this.searchPerformed = true;
    }).catch((error_code) => {
      this.busy = false;
      this.searchPerformed = true;
      let msg = 'Er is iets mis gegaan bij het communiceren met de server. Controleer uw internetverbinding.';
      if(error_code < 0) msg = 'Er is iets mis gegaan bij het communiceren met de server (' + (error_code * -1) + ')';
      this.alertCtrl.create({
        title: 'Fout',
        message: msg,
        buttons: ['OK']
      }).present();
    });
  }

  select(unit){
    this.page.searchByUnitId(unit.unit_id);
    this.closeModal();
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/search-location-units/search-location-units.ts